export default __webpack_public_path__ + "static/media/detail_big_14_7.0730ad44.jpg";